import {
  Avatar,
  Badge,
  Box,
  Flex,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import Card from 'components/card/Card';
import AvailabilitySettingsCard from 'pages/professional/profile/components/AvailabilitySettingsCard';
import NotificationsConfigCard from 'pages/professional/profile/components/NotificationsConfigCard';
import { useCurrentDbUser } from 'hooks/useCurrentUser';
import { useUser } from '@clerk/clerk-react';

const ROLE_LABELS: Record<string, string> = {
  admin:          'Administrador',
  fisioterapeuta: 'Fisioterapeuta',
  medico:         'Médico',
  pasante:        'Pasante',
  paciente:       'Paciente',
};

const ROLE_COLORS: Record<string, string> = {
  admin:          'purple',
  fisioterapeuta: 'teal',
  medico:         'blue',
  pasante:        'orange',
  paciente:       'gray',
};

export default function ProfilePage() {
  const { user: clerkUser } = useUser();
  const { data: me } = useCurrentDbUser();

  const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');
  const mutedColor       = useColorModeValue('secondaryGray.500', 'secondaryGray.400');

  const displayName = me?.nombres
    ? `${me.nombres} ${me.apellidos ?? ''}`.trim()
    : clerkUser?.fullName ?? clerkUser?.emailAddresses[0]?.emailAddress ?? '—';

  const email = clerkUser?.emailAddresses[0]?.emailAddress ?? me?.email ?? '—';
  const role  = me?.role ?? '';

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }} maxW='860px' mx='auto'>

      {/* User info card */}
      <Card mb='20px'>
        <Flex align='center' gap='16px'>
          <Avatar
            name={displayName}
            src={clerkUser?.imageUrl}
            size='lg'
            bg='brand.500'
            color='white'
          />
          <Box flex={1}>
            <Flex align='center' gap='10px' mb='2px'>
              <Text color={textColorPrimary} fontWeight='bold' fontSize='xl'>
                {displayName}
              </Text>
              {role && (
                <Badge colorScheme={ROLE_COLORS[role] ?? 'gray'} borderRadius='full' px='10px' fontSize='xs'>
                  {ROLE_LABELS[role] ?? role}
                </Badge>
              )}
            </Flex>
            <Text color={mutedColor} fontSize='sm'>{email}</Text>
            {me?.cedula && (
              <Text color={mutedColor} fontSize='xs' mt='2px'>CI: {me.cedula}</Text>
            )}
          </Box>
        </Flex>
      </Card>

      {/* Availability settings */}
      <AvailabilitySettingsCard mb='20px' />

      {/* Notifications toggle */}
      <NotificationsConfigCard />

    </Box>
  );
}
